import { BlogEntityTypeEnum } from '@/fo/api/magento';
import { Article } from '@/fo/ui/article/tile/base';

export type ArticleItem = Article & {
  type: BlogEntityTypeEnum;
};

export interface SortOption {
  label: string;
  value: string;
}

export interface FilterOption {
  label: string;
  value: string;
}

export enum SortOptionEnum {
  Popular = 'popular',
  Newest = 'newest',
  WithNaos = 'withNaos'
}

export const DEFAULT_SORT_OPTION = SortOptionEnum.Newest;
